import { Stack, Typography } from '@mui/material';
import Widget from '@/components/common/widget.tsx';
import { useTranslations } from '@/i18n/use-translations.tsx';
import type { TranslationKey } from '@/i18n/translation-key.tsx';
import type { PlayerDto } from '@/types/dtos/player/response/player.dto';
import type { PlayerParentEntity } from '@/types/dtos/player/player-parent-entity';
import type { LiveContextDto } from '@/types/dtos/live-contexts/live-context.dto';
import { ConfigurationPlayerSection } from './configuration-player-section';

type BroadcastConfigurationWidgetProps = {
  onlinePlayers: PlayerDto[];
  entityId: string;
  entityType: PlayerParentEntity;
  eventSlotId?: string | null;
  liveContext?: LiveContextDto | null;
  disabled?: boolean;
  videoPlayerId?: string | null;
  audioPlayerId?: string | null;
};

export function BroadcastConfigurationWidget({
  onlinePlayers,
  entityId,
  entityType,
  eventSlotId,
  liveContext,
  disabled,
  videoPlayerId,
  audioPlayerId,
}: BroadcastConfigurationWidgetProps) {
  const t = useTranslations();

  return (
    <Widget title={t('flows.detail.configuration.broadcast.title' as TranslationKey)} titleVariant="h6">
      <Stack spacing={2}>
        <Typography variant="body2" color="text.secondary">
          {t('flows.detail.configuration.broadcast.intro' as TranslationKey)}
        </Typography>

        <ConfigurationPlayerSection
          title={t('flows.detail.configuration.broadcast.onlinePlayer.title' as TranslationKey)}
          intro={t('flows.detail.configuration.broadcast.onlinePlayer.intro' as TranslationKey)}
          players={onlinePlayers}
          playerType="onlinePlayer"
          scrollable
          entityId={entityId}
          entityType={entityType}
          eventSlotId={eventSlotId}
          liveContext={liveContext}
          disabled={disabled}
          videoPlayerId={videoPlayerId}
          audioPlayerId={audioPlayerId}
        />
      </Stack>
    </Widget>
  );
}
